import React from 'react';
import { AlertCircle } from 'lucide-react';

const ErrorOverlay = ({ error }) => {
  if (!error) return null;
  return (
    <div className="absolute inset-0 bg-slate-500 bg-opacity-75 flex items-center justify-center z-10">
      <div className="text-center text-red-600">
        <AlertCircle size={48} className="mx-auto mb-4" />
        <p className="text-lg font-semibold">Error</p>
        <p className="text-sm">{error}</p>
      </div>
    </div>
  );
};
export default ErrorOverlay;